export default theme => ({
    cellGrey: {
        backgroundColor:"#013F8D", color:"white", border:"1px solid", lineHeight:"0.5", padding:"2px",textAlign:"center",
    },
    typoMont:{
        fontFamily: 'Montserrat',
        fontSize:"0.6rem",
        fontWeight:"bold",
    },
    Mont:{
        fontFamily: 'Montserrat',
    },
    cell: {
        textAlign:"center",
        lineHeight:"0.5",
        padding:"2px"
    },
    cellWhite: {
        border:"1px solid",
        textAlign:"center",
        lineHeight:"0.5",
        padding:"2px"
    },
    
    cellWhiteRightLeft: {
        borderRight:"1px solid",
        borderLeft:"1px solid",
        textAlign:"center",
        lineHeight:"0.5",
        padding:"2px"
    },
    cellWhiteRightLeftBottom: {
        borderRight:"1px solid",
        borderLeft:"1px solid",
        borderBottom:"1px solid",
        textAlign:"center",
        lineHeight:"0.5",
        padding:"2px"
    },
    cellWhiteRight: {
        borderRight:"1px solid",
        textAlign:"center",
        lineHeight:"0.5",
        padding:"2px"
    },
    cellWhiteRightBottom: {
        borderRight:"1px solid",
        borderBottom:"1px solid",
        textAlign:"center",
        lineHeight:"0.5",
        padding:"2px"
    },
    cellWhiteBottom: {
        borderBottom:"1px solid",
        textAlign:"center",
        lineHeight:"0.5",
        padding:"2px"
    },
    cellBlueGrey:{
        backgroundColor:"#ff7800", color:"white", border:"1px solid",textAlign:"center",lineHeight:"0.5",
        padding:"2px"
    },
    colorMov:{
        color:"#ff7800"
    }
    
  });
  
  


// WEBPACK FOOTER //
// ./src/layouts/components/content/Control/styles.jsx